var _circle, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCivAnswered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 7,
    fill: "#606060"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49609,
    cy: 7,
    r: 7,
    fill: "url(#paint0_linear_3959_16922)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49609,
    cy: 7,
    r: 6.96396,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 0.0720721
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3959_16922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09 9.06C3.82 9.06 3.56833 9.01667 3.335 8.93C3.105 8.84 2.905 8.71333 2.735 8.55C2.565 8.38667 2.43167 8.195 2.335 7.975C2.24167 7.755 2.195 7.51333 2.195 7.25C2.195 6.98667 2.24167 6.745 2.335 6.525C2.43167 6.305 2.565 6.11333 2.735 5.95C2.90833 5.78667 3.11 5.66167 3.34 5.575C3.57 5.485 3.82167 5.44 4.095 5.44C4.39833 5.44 4.67167 5.49333 4.915 5.6C5.16167 5.70333 5.36833 5.85667 5.535 6.06L5.015 6.54C4.895 6.40333 4.76167 6.30167 4.615 6.235C4.46833 6.165 4.30833 6.13 4.135 6.13C3.97167 6.13 3.82167 6.15667 3.685 6.21C3.54833 6.26333 3.43 6.34 3.33 6.44C3.23 6.54 3.15167 6.65833 3.095 6.795C3.04167 6.93167 3.015 7.08333 3.015 7.25C3.015 7.41667 3.04167 7.56833 3.095 7.705C3.15167 7.84167 3.23 7.96 3.33 8.06C3.43 8.16 3.54833 8.23667 3.685 8.29C3.82167 8.34333 3.97167 8.37 4.135 8.37C4.30833 8.37 4.46833 8.33667 4.615 8.27C4.76167 8.2 4.895 8.095 5.015 7.955L5.535 8.435C5.36833 8.63833 5.16167 8.79333 4.915 8.9C4.67167 9.00667 4.39667 9.06 4.09 9.06ZM7.11734 9L5.60734 5.5H6.48234L7.80234 8.6H7.28734L8.62734 5.5H9.43234L7.91734 9H7.11734ZM9.72457 9V5.5H10.5346V8.34H12.2896V9H9.72457Z",
    fill: "white",
    fillOpacity: 0.92
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3959_16922",
    x: 2.19531,
    y: 5.44141,
    width: 10.3109,
    height: 3.8334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.216216,
    dy: 0.216216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.18018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3959_16922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3959_16922",
    x1: 14.6304,
    y1: 3.00354,
    x2: 2.43956,
    y2: 12.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FFC843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#F4D998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#F8B106"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivAnswered);
export default __webpack_public_path__ + "static/media/civ_answered.28ef35ad7eb2ec38372d0b89477984b4.svg";
export { ForwardRef as ReactComponent };